import React from 'react';
import { Tag } from '@fiverr-private/data_display';
import { Typography } from '@fiverr-private/typography';

interface SectionTagProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  ariaLabel?: string;
}

export const SectionTag: React.FC<SectionTagProps> = ({ children, onClick, ariaLabel }) => (
  <Tag size="sm" onClick={onClick} ariaLabel={ariaLabel}>
    <Typography whiteSpace="nowrap">{children}</Typography>
  </Tag>
);
